var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgReset(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66666 17.4585C7.98611 17.2502 6.59374 16.5175 5.48958 15.2606C4.38541 14.0036 3.83333 12.5279 3.83333 10.8335C3.83333 9.91683 4.01388 9.03836 4.37499 8.19808C4.73611 7.3578 5.24999 6.62516 5.91666 6.00016L7.10416 7.18766C6.57638 7.65988 6.17708 8.2085 5.90624 8.8335C5.63541 9.4585 5.49999 10.1252 5.49999 10.8335C5.49999 12.0557 5.88888 13.1356 6.66666 14.0731C7.44444 15.0106 8.44444 15.5835 9.66666 15.7918V17.4585ZM11.3333 17.4585V15.7918C12.5417 15.5696 13.5382 14.9932 14.3229 14.0627C15.1076 13.1321 15.5 12.0557 15.5 10.8335C15.5 9.44461 15.0139 8.26405 14.0417 7.29183C13.0694 6.31961 11.8889 5.8335 10.5 5.8335H10.4375L11.3542 6.75016L10.1875 7.91683L7.27083 5.00016L10.1875 2.0835L11.3542 3.25016L10.4375 4.16683H10.5C12.3611 4.16683 13.9375 4.81266 15.2292 6.10433C16.5208 7.396 17.1667 8.97238 17.1667 10.8335C17.1667 12.5141 16.6146 13.9828 15.5104 15.2397C14.4062 16.4967 13.0139 17.2363 11.3333 17.4585Z",
    fill: "#212121"
  })));
}

export default __webpack_public_path__ + "media/b5f49520.svg";
export { SvgReset as ReactComponent };